import styled from "styled-components/macro";
import {
  colors,
  space,
  fontSize,
  fontStyle,
  iconSize,
} from "shared/styles/constants";
import { FancyButtonLink } from "shared/components/Link";

export const StyledLabel = styled.label`
  display: flex;
  align-items: center;

  margin-bottom: ${space.xs};

  svg {
    width: ${iconSize.m};
    height: ${iconSize.m};

    margin-right: ${space.xxs};
  }
`;

export const Asterisk = styled.span`
  ${fontStyle.bold}
  color: ${colors.red};

  margin-left: ${space.xxs};

  &::after {
    content: "*";
  }
`;

export const FieldLink = styled(FancyButtonLink)`
  margin-left: ${space.xs};

  ${fontSize.xs}
`;
